import {
    Slider,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
    Button,
    IconButton,
    Autocomplete,
    Tooltip, Stack, Collapse, Switch,
    //Popper,
    Paper,
    Box, FormControlLabel, RadioGroup, Radio, FormLabel, FormControl
} from "@mui/material";
import {createFilterOptions} from '@mui/material/Autocomplete';
import AddIcon from "@mui/icons-material/Add";
import AddOutlinedIcon from "@mui/icons-material/AddCircleOutline";
import DeleteIcon from "@mui/icons-material/Delete";
import {whitelist} from "../../utils/keyboardLayout"
import {useDispatch, useSelector} from "react-redux";
import {
    deleteJob,
    pushJob, setCatalogJobsDetailName,
    setCatalogJobsOperationName, setCustomJobsDetailName,
    setCustomJobsOperationName, setDetailHidden, setJobAllEngines, setJobDifficulty,
    setJobSdhHours,
    setCustomJobsSystems, repairTips
} from "../../redux/jobsSlice";
import React, {useCallback, useEffect, useState, memo, useRef, useMemo} from "react";
import {
    abcOperations,
    abcParts, getCount,
} from "../../serverREST";
import {setAllDetails} from "../../redux/listsSlice";
import debounce from "../../utils/debounce";
import {jobsFinalSum, jobsFinalVat, jobsHoursSum, sumWithVAT, vatString, filterDetail, filterJob} from "./TableSums";
import AlertIcon from "@mui/icons-material/ErrorOutline";
import InfoIcon from "@mui/icons-material/InfoOutlined";
import {changeShowComplexity, VATs} from "../../redux/settingsSlice";
import {NumericField} from "./NumberField";
import {useChangesBlocker} from "../../utils/useChangesBlocker";
import {fixLayout} from "../../utils/keyboardLayout";
import {useTranslation} from 'react-i18next';
import {CircularProgress, Typography} from "@mui/material";

function Difficulty({index, job, isEdit}) {
    // const {setFieldValue} = useFormikContext();
    // const [difficulty, setDifficulty] = useState(props.job.difficulty)
    const dispatch = useDispatch()
    // const diffFlag = useSelector(state => state.settings.diffFlag)

    return (
        <Slider
            size="small"
            step={0.1}
            // marks
            disabled={!isEdit}
            value={job.difficulty}
            onChange={(event) => {
                dispatch(setJobDifficulty({index: index, difficulty: event.target.value}))
            }}
            min={0.5}
            max={2}
            aria-label="Small"
            valueLabelDisplay="auto"/>
    )
}

function CustomSystems({job, index, customSystem}) {
    const carSystems = useSelector(state => state.lists.systems);
    const dispatch = useDispatch();
    const {i18n, t} = useTranslation();
    const currentLang = i18n.language.split('-')[0];

    const [superSystemName, setSuperSystemName] = useState(null);
    const [systemName, setSystemName] = useState(null);

    useEffect(() => {
        setSuperSystemName(job?.superSystem || null)
        setSystemName(job?.system || null)
    }, [job])
    const baseFilter = createFilterOptions({
        matchFrom: 'any',
        trim: true,
    });
    const filterOptions = (options, params) => {
        const input = params.inputValue || '';
        let valChange = fixLayout(input.trim(), currentLang);
        if (input.trim() === valChange) {
            return baseFilter(options, {
                ...params,
                inputValue: `${input}`,
                stringify: (option) => option.system,
            });
        } else {
            return baseFilter(options, {
                ...params,
                inputValue: `${valChange}`,
                stringify: (option) => option.system,
            });
        }
    };
    const filterOptionsSyperSystem = (options, params) => {
        const input = params.inputValue || '';
        let valChange = fixLayout(input.trim(), currentLang);
        if (input.trim() === valChange) {
            return baseFilter(options, {
                ...params,
                inputValue: `${input}`,
                stringify: (option) => option.super_system,
            });
        } else {
            return baseFilter(options, {
                ...params,
                inputValue: `${valChange}`,
                stringify: (option) => option.super_system,
            });
        }
    };
    const superSystem = useMemo(() => {
        return Array.from(
            new Map(
                carSystems
                    .filter(item => {
                        return item.super_system && item.super_system_id;
                    })
                    .map(item => [item.super_system_id, {
                        super_system_id: item.super_system_id,
                        super_system: item.super_system[0].toUpperCase() + item.super_system.slice(1)
                    }])
            ).values()
        );
    }, [carSystems]);
    const order = [
        "Двигатель",
        "Трансмиссия",
        "Подвеска",
        "Рулевое управление",
        "Тормоза",
        "Кондиционер, отопление, вентиляция",
        "Система пассивной безопасности (SRS)",
        "DAS / Системы помощи водителю",
        "Кузов - электрооборудование",
        "Кузов - элементы",
        "Собственные нормативы"
    ];
    superSystem.sort((a, b) => {
        const idxA = (order.indexOf(a.super_system) === -1 ? (order.indexOf("Собственные нормативы") - 0.5) : order.indexOf(a.super_system));
        const idxB = (order.indexOf(b.super_system) === -1 ? (order.indexOf("Собственные нормативы") - 0.5) : order.indexOf(b.super_system));
        return idxA - idxB;
    });

    const system = useMemo(() => {
        if (superSystemName === null) return [];
        return Array.from(
            new Map(
                carSystems
                    .filter(item => item.system && item.system_id && item.super_system_id === superSystemName.super_system_id)
                    .map(item => [
                        item.system_id,
                        {
                            system: item.system,
                            system_id: item.system_id
                        }
                    ])
            ).values()
        )
            ;
    }, [superSystemName, carSystems]);
    system.sort((a, b) => a.system.localeCompare(b.system, "ru", {sensitivity: "base"}));
    if (!job.detail.part_id && job.detail.part_name !== '' && customSystem) {
        return (
            <>
                <TableRow>
                    <TableCell colSpan={2}>
                        <Box sx={{
                            display: "flex",
                            flexDirection: 'row',
                            alignItems: 'center',
                            justifyContent: 'start',
                            gap: "10px"
                        }}
                        >
                            <Autocomplete
                                noOptionsText="Ничего не найдено"
                                value={superSystemName}
                                options={superSystem}
                                renderOption={(props, option) => (
                                    <li {...props} key={option.super_system_id}>
                                        {option.super_system}
                                    </li>
                                )}
                                isOptionEqualToValue={(option, value) =>
                                    option.super_system_id === value.super_system_id
                                }
                                onChange={(event, newValue) => {
                                    if (newValue) {
                                        setSuperSystemName(newValue)
                                        setSystemName(null);
                                        dispatch(setCustomJobsSystems({
                                            index,
                                            superSystem: {
                                                super_system_id: newValue.super_system_id,
                                                super_system: newValue.super_system,
                                            },
                                            system: null
                                        }))
                                    } else {
                                        setSuperSystemName(null)
                                        setSystemName(null);
                                        dispatch(setCustomJobsSystems({
                                            index,
                                            superSystem: null,
                                            system: null
                                        }))
                                    }
                                }}
                                getOptionLabel={(option) => option.super_system}

                                filterOptions={filterOptionsSyperSystem}
                                sx={{width: "100%"}}
                                renderInput={(params) => <TextField
                                    {...params}

                                    sx={{"& .MuiInputBase-input::placeholder": {color: "red"}}}
                                    label={!job?.superSystem?.super_system_id ? `Выберите раздел для новой детали` : `Раздел`}
                                    size={'small'}
                                    variant={'outlined'}
                                    error={!job?.superSystem?.super_system_id}
                                />
                                }
                            />

                            <Autocomplete
                                noOptionsText="Ничего не найдено"
                                value={systemName}
                                options={system}
                                isOptionEqualToValue={(option, value) =>
                                    option.system_id === value.system_id
                                }
                                onChange={(event, newValue) => {
                                    if (newValue) {
                                        setSystemName(newValue);
                                        dispatch(setCustomJobsSystems({
                                            index,
                                            system: {
                                                system_id: newValue.system_id,
                                                system: newValue.system,
                                            },
                                        }))
                                    } else {
                                        setSystemName(null);
                                        dispatch(setCustomJobsSystems({
                                            index,
                                            system: null,
                                        }))
                                    }
                                }}
                                getOptionLabel={(option) => option.system}
                                filterOptions={filterOptions}
                                sx={{width: "100%"}}
                                disabled={superSystemName === null}
                                renderInput={(params) => <TextField
                                    {...params}
                                    sx={{
                                        "& .MuiInputBase-input::placeholder": {color: "red"},
                                    }}
                                    error={!job?.system?.system_id}

                                    size={'small'}
                                    variant={'outlined'}
                                    label={!job?.system?.system_id ? `Выберите систему для новой детали` : `Система`}
                                />
                                }
                            />
                        </Box>
                    </TableCell>
                    <TableCell colSpan={6}>
                        <FormControl>
                            <FormLabel>Работа относится:</FormLabel>
                            <RadioGroup
                                row
                                aria-labelledby="demo-row-radio-buttons-group-label"
                                name="row-radio-buttons-group"
                            >
                                <FormControlLabel value="true"
                                                  control={<Radio checked={job.allEngines} onChange={() => {
                                                      dispatch(setJobAllEngines({index: index, status: true}))
                                                  }}/>}
                                                  label="ко всему модельному ряду"/>
                                <FormControlLabel value="false"
                                                  control={<Radio
                                                      onChange={() => {
                                                          dispatch(setJobAllEngines({index: index, status: false}))
                                                      }}
                                                      checked={!job.allEngines}/>}
                                                  label="к выбранному двигателю"/>

                            </RadioGroup>
                        </FormControl>
                    </TableCell>
                </TableRow>
            </>
        );
    }
    if (!job.job_id) {
        return (<TableRow><TableCell colSpan={4}>
            <FormControl>
                <FormLabel>Работа относится:</FormLabel>
                <RadioGroup
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="row-radio-buttons-group"
                >
                    <FormControlLabel value="true"
                                      control={<Radio checked={job.allEngines} onChange={() => {
                                          dispatch(setJobAllEngines({index: index, status: true}))
                                      }}/>}
                                      label="ко всему модельному ряду"/>
                    <FormControlLabel value="false"
                                      control={<Radio
                                          onChange={() => {
                                              dispatch(setJobAllEngines({index: index, status: false}))
                                          }}
                                          checked={!job.allEngines}/>}
                                      label="к выбранному двигателю"/>

                </RadioGroup>
            </FormControl>
        </TableCell></TableRow>)
    }

    return null;
}


function CustomDetail({detail, index, operationField, customSystem}) {
    const jobs = useSelector(state => state.jobs.jobs);
    const {i18n, t} = useTranslation();
    const currentLang = i18n.language.split('-')[0];

    const allDetails = useSelector(state => state.lists.allDetails);
    const dispatch = useDispatch()
    const [text, setText] = React.useState(null);
    const [isLoading, setLoading] = React.useState(false);
    const debounceSearch = useMemo(
        () =>
            debounce(async (value) => {
                try {
                    await abcParts(value, true);
                } finally {
                    setLoading(false);
                    setText(null);
                }
            }, 750),
        [abcParts]
    );

    useEffect(() => {
        return () => {
            debounceSearch.cancel(setLoading);
        };
    }, [debounceSearch]);

    const checkCustomComplite = (event) => {

        if (!jobs[index]?.detail?.part_id && jobs[index]?.detail?.part_name?.trim() !== '') {
            if (allDetails.length) {
                const result = allDetails.find(
                    p => p.part_name.toLowerCase()?.trim() === event.target.value?.toLowerCase()?.trim()
                );
                if (result) {
                    dispatch(setCatalogJobsDetailName(
                        {...result, index: index}));

                    return;
                }
            }
            const resultJob = jobs.find((job, indexJob) => {
                if (index === indexJob) return false;
                return (
                    (job.detail?.part_name?.toLowerCase() === jobs[index].detail?.part_name?.toLowerCase())
                );
            });
            if (resultJob && resultJob.system && resultJob.superSystem) {
                dispatch(setCustomJobsSystems(
                    {
                        index: index,
                        superSystem: resultJob.superSystem,
                        system: resultJob.system
                    }))
            } else {
                customSystem(true);
            }
        }


    }
    const handleChange = (val) => {
        if (val !== '') {
            setLoading(true);
            debounceSearch(text ? text : val)
        }
        dispatch(setCustomJobsDetailName(
            {
                index: index,
                part_name: val,
            }))
        dispatch(setCustomJobsSystems({
            index,
            system: null,
            superSystem: null,
        }))
    }
    return (
        <Autocomplete
            // filterOptions={filterOptions}
            filterOptions={(options, state) => options}
            style={{flexGrow: 1}}
            loading={isLoading}
            loadingText={text ? `${t('help_search_detail')} ${text}` : t('load_text')}
            clearIcon={
                isLoading ?
                    <CircularProgress
                        size={16}
                        color={"inherit"}
                    /> : undefined
            }
            freeSolo
            value={detail}
            groupBy={(option) => option.system_name}
            filterSelectedOptions
            noOptionsText={'Ничего не найдено'}
            onChange={(event, newValue) => {
                if (newValue && newValue.hasOwnProperty('part_name') && newValue.part_name.trim() !== '') {
                    dispatch(setCatalogJobsDetailName(
                        {...newValue, index: index}))
                    dispatch(setCustomJobsOperationName(
                        {
                            index: index,
                            operation_name: '',
                        }))
                    setTimeout(() => {
                        operationField.current.focus()
                    }, 1)
                } else {
                    dispatch(setCustomJobsDetailName(
                        {
                            index: index,
                            part_name: '',
                        }))
                    dispatch(setCustomJobsOperationName(
                        {
                            index: index,
                            operation_name: '',
                        }))
                    dispatch(setAllDetails([]))
                    dispatch(setCustomJobsSystems({
                        index,
                        system: null,
                        superSystem: null,
                    }))
                }
            }}
            getOptionLabel={(option) => option?.part_name || ''}
            options={allDetails}
            renderInput={(params) =>
                <TextField {...params}
                           sx={{
                               "& .MuiInputBase-input::placeholder": {color: "red"},
                           }}
                           error={detail.part_name === ''}
                           onChange={(event) => {
                               let val = event.target.value.trim();
                               let valChange = fixLayout(event.target.value.trim(), currentLang);
                               const cleanWord = val.toLowerCase();
                               const white = whitelist.includes(cleanWord);

                               if (!val || valChange != val) {
                                   setText(!val ? null : white ? null : valChange)
                               }

                               handleChange(val)
                           }}
                           autoFocus={true}
                           onBlur={checkCustomComplite}
                           onFocus={(event) => {
                               dispatch(setAllDetails([]))
                               customSystem(false);
                               if (event.target.value !== '') {
                                   debounceSearch(event.target.value)
                               }
                           }}
                           placeholder="Введите название детали, жидкости или процедуры"
                    /* helperText={
                         text && text !== "" ? (
                             <Typography
                                 component="span" // чтобы не было лишнего div
                                 key={text}
                                 style={{cursor: "pointer"}}
                                 onClick={() => {
                                     handleChange(text)
                                     setText(null)
                                 }}
                             >
                                 {t('help_search_detail')}{" "}
                                 <span style={{fontWeight: "bold"}}>{text}</span>
                             </Typography>
                         ) : null
                     }*/
                           multiline
                           variant={'outlined'}
                           size={'small'}
                />
            }
        >
        </Autocomplete>
    )
}

function CustomOperation({detail, operation, index, operationField, timeNormField}) {
    const operations = useSelector(state => state.lists.operationsDict[index] || [])
    const jobs = useSelector(state => state.jobs.jobs);
    const dispatch = useDispatch();
    const {i18n, t} = useTranslation();
    const currentLang = i18n.language.split('-')[0];
    const [valChange, setValChange] = useState('');

    const checkOperation = (event) => {
        let val = event.target.value?.toLowerCase()?.trim();
        if (val !== valChange) {
            val = valChange;
        }
        if (operations.length && val !== '') {
            const result = operations.find(
                p => p.operation_name.toLowerCase()?.trim() === val
            );
            if (result) {
                dispatch(setCatalogJobsOperationName(
                    {
                        index: index,
                        operation_name: result.operation_name,
                        operation_id: result.operation_id
                    }))
            }

        }


    }
    return (
        <Autocomplete
            style={{flexGrow: 1}}
            freeSolo
            value={operation}
            filterSelectedOptions
            openOnFocus
            noOptionsText={'Ничего не найдено'}
            filterOptions={(options, params) => {
                const input = params.inputValue.toLowerCase();
                const fixed = (valChange || '').toLowerCase();

                const filtered = options.filter((opt) => {
                    const name = (opt.operation_name || '').toLowerCase();

                    return (
                        name.includes(input) ||   // поиск по вводу
                        (fixed && name.includes(fixed)) // поиск по исправленному
                    );
                });

                return filtered;
            }}
            onFocus={(event) => {
                if (detail.part_id) {
                    abcOperations(detail.part_id, index)
                } else {
                    abcOperations('-', index)
                }
            }}
            onInputChange={(event, newInputValue, reason) => {
                if (reason === 'input') {
                    const fixed = fixLayout(newInputValue.trim(), currentLang);
                    if (fixed !== newInputValue) {
                        setValChange(fixed);
                    } else {
                        setValChange('');
                    }
                    dispatch(setCustomJobsOperationName({
                        index,
                        operation_name: newInputValue,
                    }));
                }
            }}
            onChange={(event, newValue) => {

                if (newValue && newValue.hasOwnProperty("operation_name") && newValue.operation_name !== '') {
                    timeNormField.current.focus();
                    dispatch(setCatalogJobsOperationName(
                        {
                            index: index,
                            operation_name: newValue.operation_name,
                            operation_id: newValue.operation_id
                        }));
                } else {
                    dispatch(setCustomJobsOperationName(
                        {
                            index: index,
                            operation_name: '',
                        }))
                }
            }}
            getOptionLabel={(option) => option?.operation_name || valChange || ''}
            renderOption={(props, option) => (
                <li {...props} key={option.operation_id}>
                    {option?.operation_name || ''}
                </li>
            )}

            options={operations}
            renderInput={(params) =>
                <TextField
                    {...params}
                    sx={{
                        "& .MuiInputBase-input::placeholder": {color: "red"}
                    }}

                    placeholder="Выберите операцию"
                    onBlur={checkOperation}
                    inputRef={operationField}
                    multiline
                    variant={'outlined'}
                    size={'small'}

                    error={operation.operation_name === '' || !operation?.operation_name}
                />
            }
        >
        </Autocomplete>
    )
}

function ContentRow({job, index, isEdit}) {
    const dispatch = useDispatch()
    const jobsList = useSelector(state => state.lists.textSearchJobs);
    const jobsVat = useSelector(state => state.settings.vats[VATs.jobs]);
    const [choiceCustom, setChoiceCustom] = useState(false);

    const operationField = useRef();
    const timeNormField = useRef();

    const [alert, setAlert] = useState(false);

    const existJobTooltip = `Вы пытаетесь создать работу, которая уже есть в базе данных.
        Если Вы хотите изменить созданный ранее собственный норматив,
        Вам нужно удалить его из базы работ, а затем создать новый.`;
    const addDetailTooltip = `Деталь/жидкость для этого норматива скрыта. 
        Нажмите, чтобы добавить в таблицу ниже.`;

    const hasHiddenDetail = Boolean(job.detail.hidden);

    const AddDetailButton = () => {
        return (
            <Collapse orientation="horizontal" in={hasHiddenDetail} unmountOnExit>
                <Tooltip title={addDetailTooltip}>
                    <IconButton size='small' onClick={() => {
                        if (hasHiddenDetail) {
                            dispatch(setDetailHidden({index: index, hidden: false}));
                        }
                    }}>
                        <AddOutlinedIcon fontSize='medium'/>
                    </IconButton>
                </Tooltip>
            </Collapse>
        );
    };

    useEffect(() => {
        const found = jobsList.find(listJob => listJob.detail.part_name === job.detail.part_name &&
            listJob.operation.operation_name === job.operation.operation_name)
        found ? setAlert(true) : setAlert(false)

    }, [job, jobsList])

    const diffFlag = useSelector(state => state.settings.diffFlag);

    if (job.detail.detailOnly) {
        return <React.Fragment/>;
    }
    return (
        <React.Fragment>
            <TableRow key={index} sx={{
                '&:last-child td, &:last-child th': {border: 0},
                '& .MuiTableCell-root': {
                    textAlign: 'center'
                },
            }} >
                <TableCell sx={{
                    textAlign: 'left !important',
                }}>
                    <Stack direction='row' alignItems='center' justifyContent='space-between'>
                        {!job.job_id ?
                            <React.Fragment>
                                <Collapse orientation="horizontal" in={alert}>
                                    {<Tooltip sx={{mr: 1}} title={existJobTooltip}>
                                        <IconButton size={'large'} color={'error'}>
                                            <AlertIcon fontSize={'large'}/>
                                        </IconButton>
                                    </Tooltip>}
                                </Collapse>
                                <CustomDetail detail={job.detail}
                                              index={index}
                                              operationField={operationField}
                                              customSystem={setChoiceCustom}
                                />
                            </React.Fragment>
                            :
                            <Stack direction='row' alignItems={"center"}>
                                {isEdit ? <IconButton
                                    size="medium"
                                    edge="start"
                                    color="secondary"
                                    aria-label="menu"
                                    title="Дублировать работу"
                                    onClick={() => {
                                        dispatch(pushJob(job));
                                        getCount();
                                    }}
                                ><AddIcon/> </IconButton> : null}
                                {job.detail.part_name}
                            </Stack>
                        }
                        <AddDetailButton/>
                    </Stack>
                </TableCell>
                <TableCell >
                    {job.job_id || job.detail.code === 'W' ?
                        job.operation.operation_name + (job.other ? " (" + job.other + ")" : "")
                        :
                        <CustomOperation detail={job.detail} operation={job.operation} index={index}
                                         operationField={operationField} timeNormField={timeNormField}/>
                    }
                </TableCell>
                <TableCell>
                    {Math.round(job.hourPrice * (diffFlag === 1 ? job.difficulty : 1) * 100) / 100}
                </TableCell>
                <TableCell>
                    {!job.job_id
                        ? <SdhHourInput index={index} job={job} inputRef={timeNormField}/>
                        : Math.round(job.sdh_hour * (diffFlag === 0 ? job.difficulty : 1) * 100) / 100
                    }
                </TableCell>
                <TableCell sx={{maxWidth: '3em'}}>
                    {!job.job_id ?
                        null
                        :
                        <Difficulty index={index} job={job} isEdit={isEdit}/>
                    }
                </TableCell>
                {jobsVat.active &&
                    <TableCell> {vatString(jobsVat)} </TableCell>
                }
                <TableCell> {
                    sumWithVAT(
                        Math.round(job.sdh_hour * job.hourPrice * job.difficulty * 100) / 100,
                        jobsVat
                    ).toFixed(2)
                }
                </TableCell>
                <TableCell
                    align={'center'}

                >
                    <FormControlLabel
                        disabled={!isEdit}

                        control={
                            <Switch
                                checked={job?.repair_tips ? true : false}
                                onChange={(event) => {
                                    const status = event.target.checked;
                                    dispatch(repairTips({index, status}))
                                }}
                            />
                        }
                    />

                </TableCell>
                <TableCell
                    align="right"
                    sx={{
                        width: '1em'
                    }}
                    >
                    {isEdit ? <IconButton
                        // disabled={!job.custom}
                        size="medium"
                        edge="end"
                        color="secondary"
                        aria-label="menu"
                        onClick={() => {
                            // let tempJobs = [...values.jobs]
                            // tempJobs.splice(index, 1);
                            // setFieldValue('jobs', tempJobs)
                            dispatch(deleteJob(index))
                        }}
                    >
                        <DeleteIcon/>
                    </IconButton> : null}
                </TableCell>

            </TableRow>
            <CustomSystems
                index={index}
                job={job}
                customSystem={choiceCustom}
            />

        </React.Fragment>
    );
}

function SdhHourInput({index, job, inputRef}) {
    const dispatch = useDispatch();
    const [errors, setError] = useState(false);
    useEffect(() => {
        setError(job?.sdh_hour <= 0)
    }, [job]);
    //console.log(job);
    return (
        <NumericField
            inputRef={inputRef}
            size="small"
            variant={'outlined'}
            error={errors}
            sx={{
                "& input": {
                    color: errors ? "red" : "inherit"
                }, maxWidth: '6em', minWidth: '6em'
            }}
            value={Number(job.sdh_hour)}
            InputProps={{inputProps: {min: 0, max: 1000, autoComplete: 'off'}}}
            emptyValue={0}
            showEmptyValue
            allowNegative={false}
            decimalScale={2}
            onValueChange={(value) => {
                dispatch(setJobSdhHours({index: index, sdh_hour: value}))
            }}
        />
    );
}

function JobsFooter({showVat}) {
    return (
        <>
            <TableCell variant={'head'} size={'small'}>
                {`Итого: ${jobsHoursSum()}`}
            </TableCell>
            <TableCell size={'small'}/>
            {Boolean(showVat) &&
                <TableCell variant={'head'} size={'small'}>
                    {jobsFinalVat().toFixed(2)}
                </TableCell>
            }
            <TableCell variant={'head'} size={'small'}>
                {jobsFinalSum({useVat: true}).toFixed(2)}
            </TableCell>
        </>
    );
}

const MemoizedRow = memo(ContentRow);

export default function JobsTable({workID}) {
    const jobs = useSelector(state => state.jobs.jobs);
    const sdhHourPrice = useSelector(state => state.settings.sdhHourPrice);
    const jobsVat = useSelector(state => state.settings.vats[VATs.jobs]);
    const WorkFlag = useSelector(state => state.settings.editWorkOrder);
    const carProps = useSelector(state => state.carProps.info);
    let isEdit = (WorkFlag === 1);
    if (!workID) isEdit = true;

    const dispatch = useDispatch();

    useEffect(() => {
        sessionStorage.setItem('jobs', JSON.stringify(jobs));
    }, [jobs]);
    const isMiliage = useMemo(() => {
        const hasPlate = Boolean(carProps.plate);
        const hasMileage = Boolean(carProps.mileage);
        if (hasPlate !== hasMileage) return true;
        return false;
    }, [carProps])
    const isBlocked = useMemo(() => {
        if (jobs.length === 0) return false;
        for (const job of jobs) {
            if (!filterJob(job)) return true;
            if (!filterDetail(job)) return true;
        }
        return false;
    }, [jobs]);
    const {dialog: dialogBlockWork} = useChangesBlocker(isBlocked);

    var {dialog: dialogBlockMiliage} = useChangesBlocker((!isBlocked ? isMiliage : false), {
        title: "Уйти со страницы, не заполняя госномер и пробег?",
        description: `Заказ-наряд с незаполненным госномером и пробегом будет доступен только несколько дней.
Заполненный пробег и госномер позволят всегда находить заказ-наряд по госномеру.
Заполните, пожалуйста, пробег и госномер корректно.`,
        confirmText: "Да",
        cancelText: "Нет",
    });
    return (
        <>
            {dialogBlockMiliage}
            {dialogBlockWork}
            <TableContainer component={Paper} sx={{maxWidth: 1200}} elevation={4}>
                <Table sx={{tableLayout: 'fixed', width: '100%'}}>
                    <TableHead>
                        <TableRow sx={{
                            '& .MuiTableCell-root': {
                                textAlign: 'center',
                                marginLeft: "1em"
                            },
                        }}>
                            <TableCell sx={{ textAlign: 'left !important', width: '25em'}}>Деталь/жидкость/процедура</TableCell>
                            <TableCell sx={{width: '12em'}}>Операция</TableCell>
                            <TableCell sx={{width: '8em', padding:0}}>Стоимость н/ч</TableCell>
                            <TableCell sx={{width: '4em'}}>Норматив</TableCell>
                            {/*<TableCell></TableCell>*/}
                            <TableCell sx={{
                                maxWidth: '6em',
                                minWidth: '6em'}}>
                                <Stack direction={'row'} alignItems={'center'}>
                                    Сложность
                                    <Tooltip title='В данной колонке Вы можете настроить сложность работы.
                                Зайдите в настройки, чтобы выбрать на какой параметр влияет коэффициент сложности.
                                Вместо коэффициента сложности для собственных нормативов Вы увидите переключатель варианта сохранения собственной работы.'>
                                        <IconButton size={'small'}>
                                            <InfoIcon fontSize={'small'}/>
                                        </IconButton>
                                    </Tooltip>
                                </Stack>
                            </TableCell>
                            {jobsVat.active &&
                                <TableCell style={{width: '2em'}}>НДС</TableCell>
                            }
                            <TableCell style={{width: '2em'}}>Сумма</TableCell>

                            <TableCell>
                                <Stack style={{width: '8em'}} direction={'row'} alignItems={'center'}>Рекомендации
                                    <Tooltip title='Работы будут выделены в печатной форме заказ-наряда в отдельный
                                    раздел как рекомендуемые к выполнению в будущем и не будут включены в стоимость.'>
                                        <IconButton size={'small'}>
                                            <InfoIcon fontSize={'small'}/>
                                        </IconButton>
                                    </Tooltip>
                                </Stack>
                            </TableCell>

                            <TableCell/>

                        </TableRow>
                    </TableHead>
                    <TableBody >
                        {jobs.map((job, index) => {
                            return (
                                <MemoizedRow job={job} key={index} index={index} isEdit={isEdit}/>
                            )
                        })}
                        <TableRow sx={{'&:last-child td, &:last-child th': {border: 0}}}>
                            <TableCell size={'small'}>
                                {isEdit ? <Button variant={'outlined'}

                                                  startIcon={<AddIcon/>}
                                                  color={'secondary'}
                                                  onClick={() => {
                                                      dispatch(pushJob(
                                                          {
                                                              custom: true,
                                                              detail: {
                                                                  part_name: '',
                                                                  part_id: null
                                                              },
                                                              operation: {
                                                                  operation_name: '',
                                                                  operation_id: null
                                                              },
                                                              hourPrice: sdhHourPrice,
                                                              difficulty: 1,
                                                              sdh_hour: 0,
                                                              job_id: null,
                                                              allEngines: true
                                                          }
                                                      ))
                                                  }}
                                                  size={'small'}>
                                    Создать норматив
                                </Button> : null}
                            </TableCell>
                            <TableCell size={'small'}/>
                            <TableCell size={'small'}/>
                            <JobsFooter showVat={jobsVat.active}/>
                        </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>
        </>
    )
}